<template>
    <div class="content">
        <div class="item" v-for="(item, index) in local_list" :key="index" @click="cloneTemplate(index)">
            <span v-if="!item.isFree" class="vip-tag">
                {{ tagText }}
            </span>
            <div v-if="item.type == 'create'" class="thumb">
                <img class="create" src="@/home/assets/pc/search/md-add.svg" alt="create" />
            </div>
            <img v-else class="thumb" :src="item.img_url" alt="" />
            <div class="name" :data-tooltip="item.name">
                {{ item.name }}
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import { Component, Prop, Vue, Mixins, Watch } from "vue-property-decorator";
    @Component({})
    export default class LocalItem extends Vue {
        @Prop({
            type: Array,
            required: true,
        })
        local_list;
        get userInfo() {
            return this.$store.state.userInfo;
        }
        get has_create_item() {
            return this.local_list.some((item) => item.type == "create");
        }
        get tagText() {
            return this.platform != "win" || this.userInfo.vip ? this.$t("vip") : this.$t("free");
        }
        cloneTemplate(index: number) {
            (<any>window).$qt.jsCallSearchClickedExampleItem(index - (this.has_create_item ? 1 : 0));
        }
    }
</script>
<style lang="stylus" scoped>
    .content {
    	display: flex;
    	flex-wrap: wrap;
    	align-items: center;
    	.item {
    		position: relative;
    		cursor: default;
    		background: var(--backgroudTemplateColor);
    		padding: 8px;
    		margin-right: 24px;
    		margin-bottom: 24px;
    		border-radius: 8px;
    		&:hover {
    			box-shadow: 0 0 0 1px #017fff;
    			.vip-tag {
    				display: block;
    				padding: 4px 8px;
    				background: linear-gradient(98deg, #ffedd1 0%, #ffcf88 100%);
    				font-size: 11px;
    				font-weight: 700;
    				line-height: 16px;
    				color: #632400;
    				border-radius: 8px 0px 8px 0px;
    			}
    		}
    		.vip-tag {
    			display: none;
    			position: absolute;
    			left: 0;
    			top: 0;
    			z-index: 1;
    		}
    	}
    	.thumb {
    		display: block;
    		position: relative;
    		background: var(--backgroudTemplateImgColor);
    		width: 182px;
    		height: 124px;
    		margin-bottom: 12px;
    		border-radius: 6px;
    		.create {
    			position: absolute;
    			left: 0;
    			right: 0;
    			top: 0;
    			bottom: 0;
    			margin: auto;
    		}
    	}
    	.name {
    		font-size: 12px;
    		line-height: 16px;
    		color: var(--fontSearchColor);
    		width: 182px;
    		text-overflow: ellipsis;
    		overflow: hidden;
    		white-space: nowrap;
    		&:hover:before {
    			content: attr(data-tooltip);
    			background-color: var(--backgroudTooltipColor);
    			color: var(--fontTitleColor);
    			padding: 5px 8px;
    			position: absolute;
    			left: 28px;
    			bottom: 24px;
    			margin-left: 14px;
    			white-space: pre;
    			z-index: 1;
    			border-radius: 4px;
    			box-shadow: 1px 2px 1px 0px #00000040;
    		}
    	}
    }
</style>
<i18n>
{
	"zh": {
		"vip": "vip专享",
		"free": "免费试用"
	},
	"en": {
		"vip": "Premium",
		"free": "Free Trial"
	},
	"de": {
		"vip": "Premium",
		"free": "Kostenlose Testversion"
	},
	"fr": {
		"vip": "Premium",
		"free": "Essai gratuit"
	},
	"es": {
		"vip": "Premium",
		"free": "Prueba gratuita"
	},
	"jp": {
		"vip": "プレミアム",
		"free": "無料トライアル"
	},
	"pt": {
		"vip": "Premium",
		"free": "Avaliação gratuita"
	},
	"it": {
		"vip": "Premium",
		"free": "Versione di prova gratuita"
	},
	"tw": {
		"vip": "Premium",
		"free": "免費試用"
	},
	"kr": {
		"vip": "프리미엄",
		"free": "무료 평가판"
	},
	"id": {
		"vip": "Premium",
		"free": "Free Trial"
	},
	"ru": {
		"vip": "Premium",
		"free": "Бесплатная пробная версия"
	}
}
</i18n>
